import React, { useMemo, useState } from "react";
import { UploaderScroller } from "./UploaderScroller.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import JImage from "components/Elements/Image/Image.tsx";
import AvatarEditor from "react-avatar-editor";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

import "./BrandedCoverUploader.scss";

const _URL = window.URL || window.webkitURL;

const BrandedCoverSelector = React.forwardRef(
  (
    { backgroundImage, image, size, handleClick, imageSizes, setImageSizes },
    ref
  ) => {
    const { getHtmlByKey, getTextByKey } = useContent();

    const { closeModal } = useModal();
    const { addToast } = useToasts();

    const {
      getBackgroundCover,
      isSpecificBackground,
      resetSpecificMailBrandedCover,
    } = useMail();

    //scroller scaling logic
    const [scale, setScale] = useState(1);
    const handleScale = (e) => {
      const scale = parseFloat(e.target.value);
      setScale(scale);
    };

    const handleResetCover = async () => {
      const response = await resetSpecificMailBrandedCover();
      if (response.status === "success") {
        closeModal();
        addToast(getTextByKey("upload-branded-cover-success"), {
          appearance: "success",
        });
      }
    };

    useMemo(() => {
      if (image) {
        const img = new Image();
        img.onload = function () {
          setImageSizes(() => ({
            valid: this.width > 1479 && this.height > 755,
            width: this.width,
          }));
        };

        if (image.includes("data:")) {
          img.src = image;
        } else if (image !== "error") {
          const bytesChar = atob(image);
          // Buffer.from(str, 'base64') and buf.toString('base64').
          const bytes = new Uint8Array(bytesChar.length);
          for (let i = 0; i < bytesChar.length; i++) {
            bytes[i] = bytesChar.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: "image/png" });
          const url = _URL.createObjectURL(blob);
          img.src = url;
          image = url;
        }
      }
    }, [image]);

    return (
      <div className={`background-selector`}>
        <div className="background-picture">
          <div className={`background-selector-top`}>
            <JImage name="upload-cover-top" ext="png" title="" alt="" />
          </div>
          <div
            className={`background-selector-center ${
              image || getBackgroundCover() ? "background-image-selected" : ""
            }`}
            style={
              !image && !getBackgroundCover()
                ? {
                    backgroundImage: `url(${backgroundImage})`,
                    height: `${size.width / 1.96 - 20}px`,
                  }
                : {}
            }
          >
            {image && (!imageSizes.valid || image === "error") ? (
              <div className="validation-size-container">
                {getHtmlByKey("update-cover-validation-size-text")}
              </div>
            ) : null}
            {image || getBackgroundCover() ? (
              <AvatarEditor
                ref={ref}
                image={image || getBackgroundCover()}
                width={Math.round(size.width - 20)}
                height={Math.round(size.width / 1.96 - 20)}
                crossOrigin="anonymous"
                border={0}
                color={[255, 255, 255, 0.6]} // RGBA
                scale={parseFloat(scale)}
                rotate={0}
              />
            ) : (
              <div className="click-to-action-circle" onClick={handleClick}>
                <Icon name="cloud-upload" white></Icon>
                <span>{getTextByKey("background-upload-image-button")}</span>
              </div>
            )}
          </div>
          <div className={`background-selector-bottom`}>
            <JImage name="upload-cover-bottom" ext="png" title="" alt="" />
          </div>
        </div>
        {image && imageSizes.width > 1600 && image.indexOf("https://") < 0 ? (
          <UploaderScroller
            image={image}
            handleScale={handleScale}
            maxValue={imageSizes.width / 1600}
          />
        ) : isSpecificBackground() ? (
          <div
            className="reset-background-image"
            onClick={() => handleResetCover()}
          >
            {getTextByKey("reset-cover-image-text")}
          </div>
        ) : null}
      </div>
    );
  }
);

export default BrandedCoverSelector;
